import { MessageID } from "../i18n/types";

export enum StripeErrorCode {
  AuthenticationRequired = "authentication_required",
  ExpiredCard = "expired_card",
  IncorrectNumber = "incorrect_number",
  InvalidNumber = "invalid_number",
  IncorrectCvc = "incorrect_cvc",
  InvalidCvc = "invalid_cvc",
  InvalidExpiryMonth = "invalid_expiry_month",
  InvalidExpiryYear = "invalid_expiry_year",
  ProcessingError = "processing_error",
  TestmodeDecline = "testmode_decline",
  NoEstablishedConnection = "no_established_connection",
  NetworkError = "network_error",
  NetworkTimeout = "network_timeout",
  Unknown = "unknown",
}

export class StripeCardError extends Error {
  code: StripeErrorCode;

  constructor(code: StripeErrorCode) {
    super();
    this.code = code;
  }
}

export function parseStripeError(code: string): StripeErrorCode {
  switch (code) {
    case StripeErrorCode.AuthenticationRequired:
      return StripeErrorCode.AuthenticationRequired;
    case StripeErrorCode.ExpiredCard:
      return StripeErrorCode.ExpiredCard;
    case StripeErrorCode.IncorrectNumber:
      return StripeErrorCode.IncorrectNumber;
    case StripeErrorCode.InvalidNumber:
      return StripeErrorCode.InvalidNumber;
    case StripeErrorCode.IncorrectCvc:
      return StripeErrorCode.IncorrectCvc;
    case StripeErrorCode.InvalidCvc:
      return StripeErrorCode.InvalidCvc;
    case StripeErrorCode.InvalidExpiryMonth:
      return StripeErrorCode.InvalidExpiryMonth;
    case StripeErrorCode.InvalidExpiryYear:
      return StripeErrorCode.InvalidExpiryYear;
    case StripeErrorCode.ProcessingError:
      return StripeErrorCode.ProcessingError;
    case StripeErrorCode.TestmodeDecline:
      return StripeErrorCode.TestmodeDecline;
    case StripeErrorCode.NoEstablishedConnection:
      return StripeErrorCode.NoEstablishedConnection;
    case StripeErrorCode.NetworkError:
      return StripeErrorCode.NetworkError;
    case StripeErrorCode.NetworkTimeout:
      return StripeErrorCode.NetworkTimeout;
    default:
      return StripeErrorCode.Unknown;
  }
}

export function converStripeErrorToMessageId(code: StripeErrorCode): MessageID {
  switch (code) {
    case StripeErrorCode.AuthenticationRequired:
      return "stripe.error.authenticationRequired";
    case StripeErrorCode.ExpiredCard:
      return "stripe.error.expiredCard";
    case StripeErrorCode.IncorrectNumber:
      return "stripe.error.incorrectNumber";
    case StripeErrorCode.InvalidNumber:
      return "stripe.error.invalidNumber";
    case StripeErrorCode.IncorrectCvc:
      return "stripe.error.incorrectCvc";
    case StripeErrorCode.InvalidCvc:
      return "stripe.error.invalidCvc";
    case StripeErrorCode.InvalidExpiryMonth:
      return "stripe.error.invalidExpiryMonth";
    case StripeErrorCode.InvalidExpiryYear:
      return "stripe.error.invalidExpiryYear";
    case StripeErrorCode.ProcessingError:
      return "stripe.error.processingError";
    case StripeErrorCode.TestmodeDecline:
      return "stripe.error.testmodeDecline";
    case StripeErrorCode.NoEstablishedConnection:
      return "stripe.error.noEstablishedConnection";
    case StripeErrorCode.NetworkError:
      return "stripe.error.networkError";
    case StripeErrorCode.NetworkTimeout:
      return "stripe.error.networkTimeout";
    case StripeErrorCode.Unknown:
      return "stripe.error.unknown";
    default:
      return "stripe.error.unknown";
  }
}
